import AbstractRepository from "@/repositories/AbstractRepository";

export default class BundleRepository extends AbstractRepository {
    protected static resource: string = "ptf-socle-bundle";

    public static defaultFields: string[] = [
        "hierarchyOwner.uuid",
        "hierarchyOwner.brand.fullName",
        "hierarchyOwner.storeGroup.fullName",
        "hierarchyOwner.fullName",
        "hierarchyOwner.corporateName",
        "hierarchyOwner.clientCode1",
        "label",
        "campaign.uuid",
        "campaign.label",
        "campaign.startDate",
        "campaign.endDate",
        "uuid",
        "approvedAt",
        "approvedBy.displayName",
        "defaultBudget.uuid",
        "defaultBudget.label",
        "defaultBudget.validationDeadline",
        "defaultBudget.campaign.formattedWeek",
        "defaultBudget.campaign.startDate",
        "defaultBudget.campaign.endDate",
        "defaultBudget.campaign.externalCode",
        "defaultBudget.campaign.label",
        "approvalDeadline",
    ];
}
